import { FormulaWizardState } from '../formula-wizard.reducer';

export function hasNextFormula(state: FormulaWizardState): boolean {
  return state.formulaIndex + 1 < state.formulas.length;
}
